module.exports = __webpack_public_path__ + "cf61b15d6c6a801fd2ecca439fb420b3.jpg";